import { render, staticRenderFns } from "./ProducerForm.vue?vue&type=template&id=3f7e7fc6&"
import script from "./ProducerForm.vue?vue&type=script&lang=js&"
export * from "./ProducerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports